import Layout from '@/layout/layout'

const logisticsManageRouter = {
    path: '/logisticsManage',
    component: Layout,
    redirect: 'noRedirect',
    name: '物流管理',
    children: [
        {
            path: 'order',
            component: () => import('@/views/order/index'),
            name: '物流订单',
            meta: { title: '物流订单', noCache: true }
        }
    ]
}

export default logisticsManageRouter